"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Meter = exports.decodeMeter = void 0;
/*
activeEnergyConstant: 0
bias: 0
code: "KAM MC601"
currentTransformerRatio: 0
mainFuses: 0
meterid: "242400"
phases: 0
time: "0001-01-01T00:00:00Z"
timeReadAt: "0001-01-01T00:00:00Z"
voltageTransformerRatio: 0

activeEnergyConstant: 0
bias: 0
code: "/LGZ4\2ZMD4102100.B22"
currentTransformerRatio: 0
customerID: "86860916"
mainFuses: 120
manufacturer: "Landis+Gyr AG Zug"
meterid: "86860916"
phases: 0
time: "0001-01-01T00:00:00Z"
timeReadAt: "0001-01-01T00:00:00Z"
voltageTransformerRatio: 0

activeEnergyConstant: 0
bias: 0
code: ""
currentTransformerRatio: 0
customerID: "FIOR034418000017"
mainFuses: 0
manufacturer: "Pietro Fiorentini, Via Rosellini 1, Milano, Italy"
meterid: "FIO034418000017"
phases: 0
time: "0001-01-01T00:00:00Z"
timeReadAt: "0001-01-01T00:00:00Z"
voltageTransformerRatio: 0
*/

function decodeMeter(m) {
  var id = m.meterid;

  if (id == null) {
    id = m.id;
  }

  var t = new Date(m.time);
  var tra = new Date(m.timeReadAt);
  return new Meter(id, m.code, m.manufacturer, m.swVersion, m.customerID, t, tra, m.bias, m.mainFuses, m.activeEnergyConstant, m.currentTransformerRatio, m.voltageTransformerRatio, m.phases);
}

exports.decodeMeter = decodeMeter;

var Meter =
/** @class */
function () {
  function Meter(id, code, manufacturer, swVersion, customerID, time, timeReadAt, bias, mainFuses, activeEnergyConstant, currentTransformerRatio, voltageTransformerRatio, phases) {
    if (code === void 0) {
      code = "";
    }

    if (manufacturer === void 0) {
      manufacturer = "";
    }

    if (swVersion === void 0) {
      swVersion = "";
    }

    if (customerID === void 0) {
      customerID = "";
    }

    if (time === void 0) {
      time = new Date(0);
    }

    if (timeReadAt === void 0) {
      timeReadAt = new Date(0);
    }

    if (bias === void 0) {
      bias = 0;
    }

    if (mainFuses === void 0) {
      mainFuses = 63;
    }

    if (activeEnergyConstant === void 0) {
      activeEnergyConstant = 0;
    }

    if (currentTransformerRatio === void 0) {
      currentTransformerRatio = 1.0;
    }

    if (voltageTransformerRatio === void 0) {
      voltageTransformerRatio = 1.0;
    }

    if (phases === void 0) {
      phases = 3;
    }

    this.id = id;
    this.code = code;
    this.manufacturer = this.constructManufacturer(manufacturer);
    this.swVersion = swVersion;
    this.customerID = customerID;
    this.time = time;
    this.timeReadAt = timeReadAt;
    this.bias = bias;
    this.mainFuses = mainFuses;
    this.activeEnergyConstant = activeEnergyConstant;
    this.currentTransformerRatio = currentTransformerRatio;
    this.voltageTransformerRatio = voltageTransformerRatio;
    this.phases = phases;
    this.type = "";
    this.instance = "";
  }

  Meter.prototype.constructManufacturer = function (input) {
    if (input && input.length > 0) {
      return input;
    }

    ;
    var meterManufacturerJump = {
      "/LG": "Landis+Gyr"
    };

    if (this.code && this.code.length > 0) {
      if (meterManufacturerJump[this.code.substr(0, 3)]) {
        return meterManufacturerJump[this.code.substr(0, 3)];
      }
    }

    return "";
  };

  Meter.prototype.encode = function () {
    var rawMeter = {};

    if (this.id != null && this.id.length > 0) {
      rawMeter["meterid"] = this.id;
    }

    if (this.code != null && this.code.length > 0) {
      rawMeter["code"] = this.code;
    }

    if (this.manufacturer != null && this.manufacturer.length > 0) {
      rawMeter["manufacturer"] = this.manufacturer;
    }

    if (this.swVersion != null && this.swVersion.length > 0) {
      rawMeter["swVersion"] = this.swVersion;
    }

    if (this.customerID != null && this.customerID.length > 0) {
      rawMeter["customerID"] = this.customerID;
    }

    if (this.time.getTime() !== 0) {
      rawMeter["time"] = this.time;
    }

    if (this.timeReadAt.getTime() !== 0) {
      rawMeter["timeReadAt"] = this.timeReadAt;
    }

    if (this.bias != 0) {
      rawMeter["bias"] = this.bias;
    }

    if (this.mainFuses > 0 && this.mainFuses !== 63) {
      rawMeter["mainFuses"] = this.mainFuses;
    }

    if (this.activeEnergyConstant !== 0.0) {
      rawMeter["activeEnergyConstant"] = this.activeEnergyConstant;
    }

    if (this.currentTransformerRatio !== 1.0) {
      rawMeter["currentTransformerRatio"] = this.currentTransformerRatio;
    }

    if (this.voltageTransformerRatio !== 1.0) {
      rawMeter["voltageTransformerRatio"] = this.voltageTransformerRatio;
    }

    if (!(this.phases === 0 || this.phases === 3)) {
      rawMeter["phases"] = this.phases;
    }

    return rawMeter;
  };

  return Meter;
}();

exports.Meter = Meter;
exports.default = Meter;